/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Nav_BillingInputs */

const en_common_nav_billing = /** @type {(inputs: Common_Nav_BillingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Billing`)
};

const zh_common_nav_billing = /** @type {(inputs: Common_Nav_BillingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`账单`)
};

/**
* | output |
* | --- |
* | "Billing" |
*
* @param {Common_Nav_BillingInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const common_nav_billing = /** @type {((inputs?: Common_Nav_BillingInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Nav_BillingInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_common_nav_billing(inputs)
	return zh_common_nav_billing(inputs)
});
export { common_nav_billing as "common.nav.billing" }